var _style, _g, _path, _g2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_458",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 599.2 400",
    style: {
      enableBackground: "new 0 0 599.2 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.complete0{fill:#270229;}\n\t.complete1{fill:#521159;}\n\t.complete2{fill:#FAE9E7;}\n\t.complete3{fill:#F9B869;}\n\t.complete4{fill:#330434;}\n\t.complete5{fill:#FFFFFF;}\n\t.complete6{fill:#70ACFB;}\n\t.complete7{fill:#B3D7FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_461",
    transform: "translate(607.28 131.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2009",
    className: "complete0",
    d: "M-193.9,146.6l36.6,7.7h45.4l23.1-5.2l-60.9-6.9L-193.9,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2010",
    className: "complete1",
    d: "M-168,47.6l-1.5-15.2l-1.5-3.3l-4.6-1.6l-7.5,2.3l-1.1,6.6v12.9l-2,8.6l1.1,15.4l-1.1,15.6 v4.9l0.8,0.8l0.1,2.8l2.3,2.4l1.4,8l-0.8,7.2l0.1,8l2.5,18.4l-1.4,5.2h16.6v-1.3l-6.3-3.7l0.8-19.9l2-12.9l5-17.3v-3.4l4.3-2.9 l-2.7-11.3l2.7,0.6l10.7-15l3.6-0.1v-0.6l-2-0.8l3.6-0.4v-0.6l-3.3,0.1l3.6-1.7L-143,55l-3.4,1.2l2.9-1.9l-0.8-0.4l-4.4,1.7 l0.2-2.2l-0.5-0.1l-1.4,2.5l-1.4-0.4l-8.9,8.8l-3.6-14.5L-168,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2011",
    className: "complete1",
    d: "M-109.9,12.7l-3,2.7l1,1.4l0.3,10.7l3.5,1.6l-2.6,2.2l-7.1,1L-128.4,55l-9.5-7.6v-3l-1.4-3.2 l-2.2,0.2l-3.4,1.7v3l3.7,3.2l-0.3,3l13.2,11l9.5-9.8l0.2,22.7l-5.5,49.8l-3.3,7.6v7.1l-4.6,2.2l-3.9,2.7v2.2h14.4l3.4-10.2 l1.9-9.5l9.1-44.5l0.7,45.7l-0.8,3l0.3,1.7l-1,3.6l0.2,4.7l-1.7,4.3l0.5,1.1h9.1l1-4.6l5.2-64v-1.5l2.5-19.5l1.4,5.6l-1.9,24.9 l-1.3,0.8l0,3.8l0.9-0.4l0.5-1.8l0.8,2.8l-1.9,3.4l6.3-3.6l0.2-3.9l0.9-2.3l2.4-28.1l-3.2-10.5l-5.1-14.5l-6.7-2.5l-2.5-2.6 l-2.2-0.7l0.1-2.2l3.2-5l-0.2-5.7l-2-1.7l-2.2-0.2L-109.9,12.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2012",
    className: "complete2",
    d: "M467.4,23l-69.1,20.4l7,63.3l37.1,2.9l-8,31l17.5-29.5l23.9-5.8l16.1,24l-6.2-22.5l35.7-10.2 l6.2-47.9L467.4,23z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_462",
    transform: "translate(-164.238 -340.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1323",
    className: "complete3",
    d: "M642.3,355.7l-21.9-2.3l-21.3,10.1l-9.5,17.8v22.6l8.4,15l18.6,11.9l20.8,0l20.2-12.4 l5.2-30.8l-5.5-17.9L642.3,355.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1324",
    className: "complete4",
    d: "M602.6,381.5l6.3-7.8l12-2.3l-11,3.9L602.6,381.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1325",
    className: "complete4",
    d: "M655.9,384.6l-5.5-8.3l-11.7-3.4l10.5,5L655.9,384.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1326",
    className: "complete4",
    d: "M605.5,387c0,0,4.7-7.7,10.6-7s12.3,9.7,9.3,9.2s-6-7-9.1-6.6c-3.1,0.4-8.3,6.2-9.6,5.8 C605.5,388.1,604.8,387.9,605.5,387L605.5,387z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1327",
    className: "complete4",
    d: "M652.7,389.1c0,0-3.7-8-9.2-7.6s-11.8,8.9-9.1,8.6s5.9-6.6,8.7-6s7.2,6.7,8.3,6.4 S653.2,390.1,652.7,389.1L652.7,389.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1328",
    className: "complete5",
    d: "M654.2,399.6c-0.4,2.8-1.3,5.5-2.5,8.1c-2.7,5.9-8.3,12.8-19.4,12.4 c-17.9-0.5-24.2-9.3-26.5-16.1c-0.8-2.5-1.2-5-1.2-7.6c0,0,19.8,7,31.2,6.1C653.1,401,654.2,399.6,654.2,399.6L654.2,399.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1329",
    className: "complete4",
    d: "M651.8,407.6c-2.7,5.9-8.3,12.8-19.4,12.4c-17.9-0.5-24.2-9.3-26.5-16.1 c4.4,1.5,20.3,6.5,30.1,5.6C641.2,409.3,646.5,408.6,651.8,407.6L651.8,407.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1330",
    className: "complete6",
    d: "M605.3,388.6l-17.2,7.9l-5.4,8l4.2,9.9l13,1.6l4.5-9.8L605.3,388.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1331",
    className: "complete6",
    d: "M652.8,389.7l14.1,8.3l4.6,8.1l-3.2,9.8l-10.5,1.3l-3.9-9.9L652.8,389.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1332",
    className: "complete7",
    d: "M586.1,405.3l2.2,6.8l2.6-0.8l0.5-4.2l-2.1-1.8L586.1,405.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1333",
    className: "complete7",
    d: "M667,411.4l-1.6,2.1l1.6,0.7l1-1.4L667,411.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "complete1",
    d: "M442,400H40.9l-4-40.8l50.6-62.2l61.1-12.7l28.8-18.1l-0.7-13.5l-9.9-12l-3-25.1l-1.5-12.5 c0,0-9.5-11.2-8.8-12.6c0.7-1.4,0-23.2,0-23.2l3.5-4.9l0.8-25.8l0.6-21.3l16.9-23.5l41.1-10.2l33.7,4.2l18.3,16.2l6.5,13.9l3.3,7.1 l4.3,9.2v27.1h3.8l7.7,3.2v28.1l-3.5,7.7l-6,29.2l-13.7,15.8v21.1l80.1,21.1l42.1,27.4l29.5,30.6l17.9,54.8L442,400z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2013",
    className: "complete6",
    d: "M235.4,179.5l-3.7,16.6l3.7,5l5.1-5L235.4,179.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.2244f24f90145724b32ec072b4e1e3cd.svg";
export { ForwardRef as ReactComponent };